module.exports = __webpack_public_path__ + "static/media/download.7cfb9e63.svg";